/* Yum'Lube, lot L9 (23/09/2026) : tableaux lisibles sur mobile et lien « Gérer les cookies ». */
(function () {
  function tableaux() {
    var liste = document.querySelectorAll('main .rte table');
    for (var i = 0; i < liste.length; i++) {
      var table = liste[i];
      var enveloppe = table.parentElement;
      if (!enveloppe || enveloppe.classList.contains('rte') || getComputedStyle(enveloppe).overflowX === 'visible') {
        enveloppe = document.createElement('div');
        table.parentNode.insertBefore(enveloppe, table);
        enveloppe.appendChild(table);
      }
      enveloppe.classList.add('yl-table-scroll');
      var avant = enveloppe.previousElementSibling;
      if (!avant || !avant.classList.contains('yl-table-hint')) {
        var indication = document.createElement('p');
        indication.className = 'yl-table-hint';
        indication.textContent = 'Faites glisser le tableau pour voir les quatre saveurs.';
        enveloppe.parentNode.insertBefore(indication, enveloppe);
      }
    }
  }

  function ouvrirPreferencesCookies(lien) {
    var bandeau = window.privacyBanner;
    if (bandeau && typeof bandeau.showPreferences === 'function') {
      try {
        var resultat = bandeau.showPreferences();
        if (resultat && typeof resultat.catch === 'function') {
          resultat.catch(function () { window.location.href = lien.href; });
        }
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  function lienCookies() {
    var liens = document.querySelectorAll('[data-yl-cookies]');
    for (var i = 0; i < liens.length; i++) {
      liens[i].addEventListener('click', function (evenement) {
        var lien = evenement.currentTarget;
        if (ouvrirPreferencesCookies(lien)) {
          evenement.preventDefault();
          return;
        }
        if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          evenement.preventDefault();
          var fait = false;
          var secours = setTimeout(function () {
            if (!fait) { fait = true; window.location.href = lien.href; }
          }, 2500);
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
              if (fait) return;
              fait = true;
              clearTimeout(secours);
              if (!ouvrirPreferencesCookies(lien)) window.location.href = lien.href;
            });
          } catch (e) {
            fait = true;
            clearTimeout(secours);
            window.location.href = lien.href;
          }
        }
        /* Sinon, le lien mène à la politique de confidentialité. */
      });
    }
  }

  function demarrer() {
    tableaux();
    lienCookies();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
